import { getLinks } from './sidebar';

/**
 * หน้าแรกที่ควรพาผู้ใช้ไปหลัง login / หลังเปิดแท็บบริษัทใหม่
 *
 * ไม่ hardcode เป็น /workspace/case เพราะแต่ละ JobType เห็นเมนูไม่เหมือนกัน
 * เช่น Auditor ไม่มีเมนู "จัดการเคส" เลย ถ้าพาไปจะเจอหน้าที่ใช้งานไม่ได้
 * จึงหยิบเมนูตัวแรกที่คนนั้นมีสิทธิ์จริง ๆ จาก PERMISSION_MATRIX ชุดเดียวกับ sidebar
 *
 * สำหรับ Panel(Output) เมนูแรกคือ 'จัดการเคส' อยู่แล้ว — ตรงกับที่ต้องการ
 */
const firstRoute = (linkGroups) => {
  for (const group of linkGroups || []) {
    for (const link of group.links || []) {
      if (link.route) return link.route;
      // เมนูที่มีเมนูย่อย (รายงาน/ตรวจสอบ) ตัวแม่ไม่มี route ต้องเข้าไปหยิบตัวลูก
      const sub = Array.isArray(link.subLinks) ? link.subLinks : [];
      for (const child of sub) {
        if (child.route) return child.route;
      }
    }
  }
  return null;
};

export const getWorkspaceLanding = ({ role, jobType }) => {
  try {
    const route = firstRoute(getLinks(role, 'workspace', 0, jobType));
    if (route) return '/' + String(route).replace(/^\/+/, '');
  } catch (e) {
    // ถ้า PERMISSION_MATRIX เปลี่ยนรูปแบบ อย่าให้ login พัง — ตกไปใช้ค่า fallback
  }
  return '/workspace/case';
};
